module.exports = __webpack_public_path__ + "img/footer-logo-new.25978b4b.svg";